import React, { useState, useEffect, useCallback } from "react";
import "./styles/App.css";
import { useGame } from "./hooks/useGame";
import MenuScreen from "./components/MenuScreen";
import ListingScreen from "./components/ListingScreen";
import GameScreen from "./components/game/GameScreen";
import ResultScreen from "./components/game/ResultScreen";
import SettingsScreen from "./components/SettingsScreen";
import { Box, Typography } from "@mui/material";

function App() {
  const {
    currentGameMode,
    currentQuestionIndex,
    currentScore,
    questionsAnswered,
    gameQuestions,
    gameResults,
    timeRemaining,
    timerActive,
    gameFinished,
    startGame,
    selectAnswer,
    nextQuestion,
    backToMenu,
    speakWord,
    currentQuestionData,
  } = useGame();

  const [currentScreen, setCurrentScreen] = useState("menuScreen");

  const navigateToScreen = useCallback((screenName) => {
    window.history.pushState({ screen: screenName }, "", `#${screenName}`);
    setCurrentScreen(screenName);
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      if (event.state && event.state.screen) {
        setCurrentScreen(event.state.screen);
      } else {
        setCurrentScreen("menuScreen");
      }
    };

    window.addEventListener("popstate", handlePopState);

    if (!window.history.state || !window.history.state.screen) {
      window.history.replaceState(
        { screen: currentScreen },
        "",
        `#${currentScreen}`
      );
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [currentScreen]);

  const handleStartGame = (modeName, category) => {
    startGame(modeName, category);
    navigateToScreen("gameMode");
  };

  const handleShowListing = () => {
    navigateToScreen("listingMode");
  };

  const handleShowSettings = () => {
    navigateToScreen("settingsScreen");
  };

  const handleBackToMenu = () => {
    backToMenu();
    navigateToScreen("menuScreen");
  };

  useEffect(() => {
    if (gameFinished) {
      navigateToScreen("resultScreen");
    }
  }, [gameFinished, navigateToScreen]);

  return (
    <Box className="container" sx={{ p: 2 }}>
      <Box className="header" sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          🌟 英文生字小遊戲 (朗朗專用爸爸愛心版)🌟
        </Typography>
        <Typography variant="subtitle1">趣味學習英文！完全無難度</Typography>
      </Box>
      <Box className="content">
        {currentScreen === "menuScreen" && (
          <MenuScreen
            startGame={handleStartGame}
            showListing={handleShowListing}
            showSettings={handleShowSettings}
          />
        )}
        {currentScreen === "listingMode" && (
          <ListingScreen goBack={handleBackToMenu} />
        )}
        {currentScreen === "gameMode" && (
          <GameScreen
            currentGameMode={currentGameMode}
            currentQuestionIndex={currentQuestionIndex}
            currentScore={currentScore}
            questionsAnswered={questionsAnswered}
            gameQuestions={gameQuestions}
            timeRemaining={timeRemaining}
            timerActive={timerActive}
            selectAnswer={selectAnswer}
            nextQuestion={nextQuestion}
            currentQuestionData={currentQuestionData}
            speakWord={speakWord}
            goBack={handleBackToMenu}
          />
        )}
        {currentScreen === "resultScreen" && (
          <ResultScreen
            gameResults={gameResults}
            currentScore={currentScore}
            currentGameMode={currentGameMode}
            goBack={handleBackToMenu}
            speakWord={speakWord}
          />
        )}
        {currentScreen === "settingsScreen" && (
          <SettingsScreen goBack={handleBackToMenu} />
        )}
      </Box>
    </Box>
  );
}

export default App;
